// src/api/client.js
import { getOrCreateInstallationId } from "../lib/installationId";

export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;
// export const API_BASE_URL = "http://localhost:8002";

export function getToken() {
  try {
    return localStorage.getItem("speedway_token") || "";
  } catch { return ""; }
}

export function getUser() {
  try {
    return JSON.parse(localStorage.getItem("speedway_user") || "null");
  } catch {
    return null;
  }
}

// Bygger fullständig URL av path (om path är relativ)
function buildUrl(path) {
  if (path.startsWith("http")) return path;
  const base = API_BASE_URL.replace(/\/$/, "");
  const rel = path.startsWith("/") ? path : `/${path}`;
  return `${base}${rel}`;
}

const AUTH_MESSAGES = {
  session_expired: "Din session har gått ut. Logga in igen.",
  session_revoked: "Du har blivit utloggad. Logga in igen.",
  device_mismatch: "Din session kunde inte verifieras på den här enheten. Logga in igen.",
  invalid_token: "Din session är ogiltig. Logga in igen.",
  not_authenticated: "Du behöver logga in igen.",
};

export function resolveApiErrorMessage({ status, detail, responseCode, hasToken, path }) {
  if (status !== 401) return detail;

  const sessionMessage = AUTH_MESSAGES[responseCode];
  if (sessionMessage) return sessionMessage;

  const requestPath = String(path || "").split("?", 1)[0];
  const isAuthenticationRequest = requestPath.includes("/api/auth/");
  return hasToken && !isAuthenticationRequest
    ? "Du har blivit utloggad. Logga in igen."
    : detail;
}

export async function apiCall(path, options = {}) {
  const token = getToken();
  // const headers = {
  //   "Content-Type": "application/json",
  //   ...(token ? { Authorization: `Bearer ${token}` } : {}),
  //   ...(options.headers || {}),
  // };

  // Mergad Headers (options.headers kan vara både Headers eller Record)
  const headers = new Headers(options.headers || {});
  if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json");
  const installationId = getOrCreateInstallationId();
  if (installationId) headers.set("X-Lapstr-Installation-Id", installationId);
  if (token) headers.set("Authorization", `Bearer ${token}`); // <-- SÄTT SIST

  // const url = path.startsWith("http") ? path : `${API_BASE_URL}${path}`;
  const url = buildUrl(path);

  let res;
  try {
    res = await fetch(url, { ...options, headers, credentials: "include" });
  } catch (e) {
    const err = new Error("Nätverksfel – kunde inte nå servern.");
    err.cause = e;
    throw err;
  }

  const ct = res.headers.get("content-type") || "";
  const isJSON = ct.includes("application/json");
  const payload = isJSON
    ? await res.json().catch(() => null)
    : await res.text().catch(() => "");

  if (!res.ok) {
    const detailObject =
      payload && typeof payload.detail === "object" && payload.detail !== null
        ? payload.detail
        : null;
    const detailSource =
      detailObject?.message ??
      (payload && (payload.detail ?? payload.message ?? payload.error));
    const detail =
      typeof detailSource === "string" && detailSource.trim()
        ? detailSource.trim()
        : typeof payload === "string" && payload.trim()
          ? payload.trim()
          : `${res.status} ${res.statusText}`;

    const responseCode =
      detailObject?.code ??
      (payload && typeof payload.code === "string" ? payload.code : undefined);
    const userFacingDetail = resolveApiErrorMessage({
      status: res.status,
      detail,
      responseCode,
      hasToken: Boolean(token),
      path,
    });

    const err = new Error(userFacingDetail);
    err.status = res.status;
    err.code = responseCode;
    const retryAfterHeader = res.headers.get("Retry-After");
    const retryAfterSeconds = Number.parseInt(retryAfterHeader || "", 10);
    if (Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0) {
      err.retryAfter = retryAfterSeconds;
    }

    // ⛔️ Fångar ogiltig/återkallad session globalt
    if (res.status === 401 && token) {
      // Lägg en notis som AuthPage plockar upp och visar som toast
      sessionStorage.setItem(
        "auth_notice",
        userFacingDetail
      );

      // Rensa lokal auth om något hann ligga kvar
      try {
        localStorage.removeItem("speedway_token");
        localStorage.removeItem("speedway_user");
      } catch { }

      // Sänd global signal så att AuthContext direkt nollar användaren
      try {
        window.dispatchEvent(
          new CustomEvent("auth:logout", { detail: { reason: "401" } })
        );
      } catch { }
    }

    throw err;
  }

  return isJSON ? payload : null;
}


